import { action, createRequestTypes } from '@/utils/actions.utils'
import { orderService } from '@/services'
import { uiActions } from '@/redux/actions'
import { ERROR_403_PATH } from '@/constants'

export const GENERATE_ORDER = createRequestTypes('GENERATE_ORDER')
const generateOrder = ({ projectId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			let response = await orderService.getProjectAndOrderByProjectId({ projectId, lang });
			const order = response.data.order;
			const res = {payload: response.data.project};

			return dispatch(success({ project: res.payload, order }))
		} catch (error) {
			if (error?.response?.status === 403) {
				dispatch(uiActions.navigateTo({ path: ERROR_403_PATH }))
			}

			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GENERATE_ORDER.REQUEST)
	}
	function success(payload) {
		return action(GENERATE_ORDER.SUCCESS, payload)
	}
	function failure(err) {
		return action(GENERATE_ORDER.FAILURE, null, err)
	}
}

export const GET_ORDER = createRequestTypes('GET_ORDER')
const getOrder = ({ orderId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await orderService.getOrder({ orderId, lang })
			return dispatch(success(res.data))
		} catch (error) {
			if (error?.response?.status === 403) {
				dispatch(uiActions.navigateTo({ path: ERROR_403_PATH }))
			}

			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_ORDER.REQUEST)
	}
	function success(payload) {
		return action(GET_ORDER.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_ORDER.FAILURE, null, err, false)
	}
}

export const PROCESS_ORDER = createRequestTypes('PROCESS_ORDER')
const processOrder = ({ order }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await orderService.processOrder({
				...order,
				products: order.products.orderedIds.reduce((acc, id) => {
					return [...acc, order.products.byId[id]]
				}, [])
			})
			return res?.response?.processOrderSuccess === false
				? dispatch(
					failure(
						res,
						res.response.data,
						res?.response?.processOrderSuccess
					)
				)
				: dispatch(success(res.data))

		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(PROCESS_ORDER.REQUEST)
	}
	function success(payload) {
		return action(PROCESS_ORDER.SUCCESS, payload)
	}
	function failure(err, payload = {}, showError = true) {
		return action(PROCESS_ORDER.FAILURE, payload, err, showError)
	}
}

export const UPDATE_ORDER_COMMENTS = 'UPDATE_ORDER_COMMENTS'
const updateOrderComments = ({ comments }) => {
	return action(UPDATE_ORDER_COMMENTS, { comments })
}
export const UPDATE_ORDER_INTERNAL_NUM = 'UPDATE_ORDER_INTERNAL_NUM'
const updateOrderInternalNum = ({ text }) => {
	return action(UPDATE_ORDER_INTERNAL_NUM, { text })
}

export const UPDATE_ORDER_PRODUCT_QTY = 'UPDATE_ORDER_PRODUCT_QTY'
const updateProductQty = ({ productId, quantity }) => {
	return action(UPDATE_ORDER_PRODUCT_QTY, {
		productId,
		quantity
	})
}

export const UPDATE_ORDER_PRODUCT_SHIPPINGDATE = 'UPDATE_ORDER_PRODUCT_SHIPPINGDATE'
const updateProductShippingDate = ({ productId, date }) => {
	return action(UPDATE_ORDER_PRODUCT_SHIPPINGDATE, {
		productId,
		date
	})
}

export const UPDATE_ORDER_PRODUCT_AVAILABILITY = 'UPDATE_ORDER_PRODUCT_AVAILABILITY'
const updateProductAvailability = ({ productId, availability }) => {
	return action(UPDATE_ORDER_PRODUCT_AVAILABILITY, {
		productId,
		availability
	})
}

export const ORDER_DELIVERY_TYPE_CHANGE = 'ORDER_DELIVERY_TYPE_CHANGE'
const orderDeliveryTypeChange = ({ sendTogether }) => {
	return action(ORDER_DELIVERY_TYPE_CHANGE, { sendTogether })
}

export const UPDATE_ORDER_PRODUCT_VALIDATION = 'UPDATE_ORDER_PRODUCT_VALIDATION'
const updateProductValiation = ({ productId, validation }) => {
	return action(UPDATE_ORDER_PRODUCT_VALIDATION, {
		productId,
		validation
	})
}

export const RESET_ORDER_COMPLETED = 'RESET_ORDER_COMPLETED'
const resetOrderCompleted = () => {
	return action(RESET_ORDER_COMPLETED)
}
export const RESET_ORDER_ERROR = 'RESET_ORDER_ERROR'
const resetOrderError = () => {
	return action(RESET_ORDER_ERROR)
}

export default {
	processOrder,
	generateOrder,
	getOrder,
	updateOrderComments,
	updateOrderInternalNum,
	updateProductAvailability,
	updateProductShippingDate,
	updateProductQty,
	updateProductValiation,
	orderDeliveryTypeChange,
	resetOrderCompleted,
	resetOrderError
}
